import React from "react";
import "./Input.scss";

const signupInput = (props) => {
  let input = (
    <input
      name={props.name}
      value={props.value}
      onChange={(e) => props.onChange && props.onChange(e.target.value)}
      placeholder={props.placeholder && props.placeholder}
      type={props.type ? props.type : "text"}
      disabled={props.disable}
      required
    />
  );
  let label = <label>{props.label}</label>;
  let description = null;
  let link = null;

  if (props.showPassword) {
    label = (
      <div className="createAndShow">
        <label>Create password</label>
        <p
          className={props.type !== "password" ? "active" : ""}
          onClick={props.showPassword}
        >
          Show passowrd
        </p>
      </div>
    );
  }

  if (props.textarea) {
    input = (
      <textarea placeholder={props.placeholder && props.placeholder}></textarea>
    );
  }

  if (props.description) {
    description = <p>{props.description}</p>;
  }

  if (props.button) {
    link = <button onClick={props.button.action}>{props.button.text}</button>;
  }

  return (
    <div
      className={
        "SignupInput" +
        (props.svg ? " svg" : "") +
        (props.phone ? " phone" : "") +
        (props.error ? " error" : "")
      }
    >
      {label}
      {description}
      {link}
      {input}
      {props.children}
    </div>
  );
};

export default signupInput;
